export const API_URL = 'https://api.familybook.uz/api'
export const MAIN_URL = 'https://api.familybook.uz'